/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import cx from 'classnames';
import _ from 'lodash';
import style from './Notes.scss';

class Notes extends Component {
  createMoreNotesMarkup = () => {
    return { __html: this.props.chunk.get('more_notes') };
  };

  createNotesMarkup = () => {
    return { __html: this.props.chunk.get('notes') };
  };

  render() {
    const hasMoreNotes = !_.isEmpty(this.props.chunk.get('more_notes'));

    const noteClasses = cx({
      left: hasMoreNotes,
    });

    return (
      <div
        className={cx('chunk-notes', {
          [style.slideshow]: this.props.isSlideshow,
        })}
        style={this.props.style}
      >
        <div
          className={cx('container clearfix', {
            [style.slideshow]: this.props.isSlideshow,
          })}
        >
          <div className={noteClasses}>
            <span dangerouslySetInnerHTML={this.createNotesMarkup()} />
          </div>
          {hasMoreNotes ? (
            <div className="right">
              <span dangerouslySetInnerHTML={this.createMoreNotesMarkup()} />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default Notes;
